import { render, staticRenderFns } from "./CoreTable.vue?vue&type=template&id=fdae4be6&"
import script from "./CoreTable.vue?vue&type=script&lang=js&"
export * from "./CoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports